import axios from 'axios';

const BASE_URL = 'https://autoseguro.api.ikeytechnologies.com/api/';

// 🔐 Función para hacer login y guardar tokens en localStorage
export const loginUser = async (credentials) => {
    try {
      const response = await axios.post(`${BASE_URL}login/`, credentials);
      const data = response.data;
  
      // Guardar tokens y datos del usuario en localStorage
      localStorage.setItem('access_token', data.access);
      localStorage.setItem('refresh_token', data.refresh);
      localStorage.setItem('user_role', data.role);
      localStorage.setItem('username', data.username);
      localStorage.setItem('user_id', data.user_id);
  
      return true;
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      return false; // Devuelve false si falla
    }
  };

// 🔁 Función para refrescar el token de acceso
export const refreshToken = async () => {
  const refresh = localStorage.getItem('refresh_token');
  if (!refresh) throw new Error('No hay refresh token almacenado.');

  try {
    const response = await axios.post(`${BASE_URL}token/refresh/`, { refresh });
    const newAccess = response.data.access;

    // Actualizar el access token en localStorage
    localStorage.setItem('access_token', newAccess);

    return newAccess;
  } catch (error) {
    console.error('Error al refrescar el token:', error);
    throw error;
  }
};

// 📥 Obtener lista de usuarios con rol 'servicio'
export const fetchUsuariosServicio = async () => {
  try {
    const response = await axios.get(`${BASE_URL}usuarios/servicio/`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener usuarios con rol servicio:', error);
    throw error;
  }
};

export const fetchUsuarioByUserId = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}usuarios/servicio/${id}/`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener usuarios con rol servicio:', error);
    throw error;
  }

}

export const logoutUser = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_role');
    localStorage.removeItem('username');
    localStorage.removeItem('user_id');
  };
  
export const getAuthHeaders = () => {
    const token = localStorage.getItem('access_token');
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  };
  